import React, { useState, useEffect } from "react";
import moment from "moment";
import { Link } from "react-router-dom";
import fbIcon from "../../assets/fb.png";
import linkIcon from "../../assets/link.png";
import { getStatus, getStatus2 } from "../../misc/misc";
import ReactHtmlParser from "react-html-parser";
import { baseURL, baseURLWeb } from "../../misc/http";
import defaultImage from "../../assets/default.jpg";
import images from "../../commons/images";
import classes from "./styles.module.scss";
import classNames from "classnames";
import Material from "./Material";
import history from "../../misc/history";

import { CopyToClipboard } from "react-copy-to-clipboard";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default ({
  collapse,
  listGuide,
  handleCollapse,
  event,
  handleShowForm,
  url,
  idEvent,
}) => {
  const [activeTab, setActiveTab] = useState("tab1");

  return (
    <section className="detail-acara">
      <div className="container row mx-auto">
        <div className="col-lg-4">
          <img
            className="mb-4"
            src={event.picture ? baseURL + "/" + event.picture : defaultImage}
            alt="grey"
            style={{ width: "100%", height: "150px", objectFit: "cover" }}
          />
          <div className="d-flex">
            <div className="text-center">
              <p
                style={{
                  fontSize: "18px",
                  color: "#15A325",
                  fontWeight: "600",
                }}
              >
                {moment(event.startDate).format("MMMM")}
              </p>
              <p style={{ fontSize: "18px", fontWeight: "600" }}>
                {moment(event.startDate).format("DD")}
              </p>
            </div>
            <div className="ml-5">
              <Link to={`/event_detil/${event._id}`} style={{ color: "black" }}>
                <p style={{ fontSize: "18px", fontWeight: "600" }}>
                  {event.title}
                </p>
              </Link>
              <p className="text-muted">
                {moment(event.startDate).format("ddd, MMMM DD")},{" "}
                {event.startTime}
              </p>
              {event.eventType === "webinar" && (
                <div className={classes.toolsIcon}>
                  <img
                    src={images[`${event.thirdPartyTool}Icon`]}
                    alt="tools"
                  />
                </div>
              )}
            </div>
          </div>
          {console.log(getStatus2(event.startDate))}
          {getStatus2(event.startDate) === 1 && (
            <>
              {event.status !== "expired" &&
                (event.thirdPartyTool === "youtube" ? (
                  <button
                    type="button"
                    className={classNames("btn mt-4", classes.btnJoin)}
                  >
                    <Link to={`/events/stream/${idEvent}`}>Tonton di Sini</Link>
                  </button>
                ) : (
                  <button
                    type="button"
                    className={classNames("btn mt-4", classes.btnJoin)}
                    onClick={handleShowForm}
                  >
                    <a>Daftar di Sini</a>
                  </button>
                ))}
            </>
          )}
        </div>
        <div className="col-lg-7 offset-lg-1">
          <div
            className="pb-3 mb-5"
            style={{ borderBottom: "1px solid rgba(0,0,0,0.12)" }}
          >
            <div className="row">
              <div className="col-lg-9 col-md-9 col-sm-12 col-12">
                <p style={{ fontSize: "25px", fontWeight: "600" }}>
                  {event.title}
                </p>
                <p className="text-muted">
                  {moment(event.startDate).format("ddd, MMMM DD")},{" "}
                  {event.startTime}
                </p>
                <p className="text-muted">{event.location}</p>
              </div>
              <div className="col-lg-3 col-md-3 col-sm-12 col-12 d-lg-block d-md-block d-sm-none d-none">
                <div
                  className="row mx-0"
                  style={{ justifyContent: "flex-end", marginBottom: "50px" }}
                >
                  {/* <a href="" className="mr-3">
                    <img
                      src={fbIcon}
                      alt="fb"
                      style={{ width: "25px", height: "25px" }}
                    />
                  </a> */}
                  <CopyToClipboard
                    text={`${baseURLWeb}${url.substring(1, url.length)}`}
                    onCopy={(e) => {
                      console.log(url);
                      toast.success("Link telah tersalin!", {
                        position: "top-right",
                        autoClose: 2000,
                        hideProgressBar: false,
                        closeOnClick: true,
                        pauseOnHover: false,
                        draggable: true,
                        progress: undefined,
                      });
                    }}
                  >
                    <a className={classes.cursor}>
                      <img
                        src={linkIcon}
                        alt="link"
                        style={{ width: "25px", height: "25px" }}
                      />
                    </a>
                  </CopyToClipboard>
                </div>
              </div>
            </div>
            <div
              className={classNames(
                "mt-2 d-flex align-items-center",
                {
                  ["justify-content-end"]: event.eventType !== "webinar",
                  ["justify-content-between"]: event.eventType === "webinar",
                },
                classes.infoType
              )}
            >
              {event.eventType === "webinar" && (
                <div className={classes.toolsIcon}>
                  <img
                    src={images[`${event.thirdPartyTool}Icon`]}
                    alt="tools"
                  />
                </div>
              )}
              <p
                style={{
                  fontSize: "14px",
                  fontWeight: "600",
                  textAlign: "right",
                  margin: 0,
                }}
              >
                GRATIS
              </p>
            </div>
          </div>
          <p style={{ fontSize: "13px" }}>
            {ReactHtmlParser(event.description)}
          </p>
          {/* <ul
            className="nav nav-pills mt-5 nav-fill"
            id="pills-kegiatan-acara-saya"
            role="tablist"
            style={{ borderBottom: "1px solid rgba(0,0,0,0.12)" }}
          >
            <li className="nav-item">
              <div
                className={
                  activeTab === "tab1" ? "nav-link active" : "nav-link"
                }
                data-toggle="pill"
                role="tab"
                aria-controls="pills-informasi"
                aria-selected="true"
                onClick={() => setActiveTab("tab1")}
              >
                Informasi Tambahan
              </div>
            </li>
            <li className="nav-item">
              <div
                className={
                  activeTab === "tab2" ? "nav-link active" : "nav-link"
                }
                id="pills-cara-regis-tab"
                data-toggle="pill"
                role="tab"
                aria-controls="pills-cara-regis"
                aria-selected="false"
                onClick={() => setActiveTab("tab2")}
              >
                Cara Registrasi
              </div>
            </li>
          </ul> */}
          <div className="tab-content" id="pills-tabKegiatanAcara">
            {/* <div
              className={
                activeTab === "tab1"
                  ? "tab-pane fade show active"
                  : "tab-pane fade show"
              }
              id="pills-informasi"
              role="tabpanel"
              aria-labelledby="pills-informasi-tab"
            >
              <ol>
                <li>Peserta diwajibkan untuk membawa alat tulis sendiri.</li>
                <li>
                  Pastikan kamu datang 30 menit sebelum registrasi ditutup.
                </li> */}
            {/* <li>Meja registrasi dibuka pada pukul {moment(event.startTime).subtract('minute', 30)}.</li> */}
            {/* <li>
                  Harap membawa KTP untuk menukarkan dengan akses masuk gedung.
                </li>
              </ol>
            </div> */}
            {/* <div
              className={
                activeTab === "tab2"
                  ? "tab-pane fade show active"
                  : "tab-pane fade show"
              }
              id="pills-cara-regis"
              role="tabpanel"
              aria-labelledby="pills-cara-regis-tab"
            > */}
            <div
              className={classNames(
                "tab-pane fade show active",
                classes.material
              )}
              id="pills-cara-regis"
              role="tabpanel"
              aria-labelledby="pills-cara-regis-tab"
            >
              <h4>Cara Registrasi</h4>
              <ol>
                <li>Klik tombol "Daftar Disini"</li>
                <li>
                  Isikan informasi diri kamu berupa; Nama, Nomor Telepon, Email
                  dan Nama Instansi.
                </li>
                <li>
                  Buka e-mail kamu untuk konfirmasi kehadiran & e-ticketing
                  webinar.
                </li>
                {event.eventType === "webinar" ? (
                  <li>
                    Kamu berhasil terdaftar! Login & masuk ke halaman acara saya
                    untuk memulai mengikuti webinar.
                  </li>
                ) : null}
              </ol>
            </div>
          </div>
          {/* {getStatus(event.endDate) !== "SUDAH SELESAI" ? (
            <button
              data-toggle="modal"
              data-target="#daftar-disini"
              className="btn btn-blue w-100"
              style={{ padding: "15px !important" }}
              onClick={() => handleShowForm()}
            >
              Daftar Disini
            </button>
          ) : null}
          {listGuide.length>0&&<Material
            collapse={collapse}
            listGuide={listGuide}
            handleCollapse={handleCollapse}
          />} */}
          {event.materials && event.materials.length > 0 && (
            <Material
              collapse={collapse}
              listGuide={event.materials}
              handleCollapse={handleCollapse}
            />
          )}
          <ToastContainer
            position="top-right"
            autoClose={2000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss={false}
            draggable
            pauseOnHover={false}
          />
        </div>
      </div>
    </section>
  );
};
